import type React from "react";
import { ReactComponent as Svg } from "./assets/navigation-menu-horizontal.svg";
import * as styles from "./Icon.module.scss";

type EllipsisProps = React.SVGProps<SVGSVGElement>;

export const Ellipsis = ({ className, ...props }: EllipsisProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
